/**
 * FreeSpins Class
 *
 * this module manages both freespins modes it inherits from spin functions
 *
 */

freespins = (function () {
  var _inFreeSpins = false;
  var _awardFreespinsTask;
  var _endFreespinsTask;

  var _initialDroppingFS = 0;
  var _bonusAnimsPlayed = false;

  var _freeSpinsMeter;
  var _bgTrail;

  var _landedAnimsPlaying = [];

  var _spinSounds = ['startPressed1', 'startPressed2', 'startPressed3'];
  var _lastRandomSpinSoundIndex = -1;

  function initialise() {
    _freeSpinsMeter = resourceManager.get('freeSpinsMeterContainer:freeSpinsMeter');
    _bgTrail = resourceManager.get('bgTrail:BGTrailContainer');
    _outcomesPanel = resourceManager.get('outcomesPanel:OutcomesPanel');
    _spinButton = resourceManager.get('buttonContainer:buttonBar:spinButton');
  }

  function canEnableSpin() {
    return freespins.stateMachine.ActiveStateName === 'READY_TO_START';
  }

  function canShowSpin() {
    return freespins.stateMachine.ActiveStateName === 'READY_TO_START';
  }

  function canEnableSkip() {
    return freespins.stateMachine.ActiveStateName === 'PAYWINS';
  }

  function canShowSkip() {
    return freespins.stateMachine.ActiveStateName === 'PAYWINS';
  }

  // this just flips the layout between freeSpins and normal
  function freespinsMode(bool) {
    _inFreeSpins = bool;
  }

  function awardFreeSpinsComplete() {
    //slotMachine.selectReelMode("freespins");
    //musicManager.onFreespinsStart();
    _awardFreespinsTask.leave();
  }

  function playSpinSound() {
    let randomSpinSoundIndex = -1;
    let goes = 5;
    do {
      randomSpinSoundIndex = game.randomNumberBetween(0, _spinSounds.length - 1);
    } while (randomSpinSoundIndex === _lastRandomSpinSoundIndex && --goes > 0);
    soundManager.play(_spinSounds[randomSpinSoundIndex]);
    _lastRandomSpinSoundIndex = randomSpinSoundIndex;
  }

  async function fadeOutComponentsBeforeBGToFSTransition() {
    const slotContainer = resourceManager.get('slotContainer');
    const goldenBetButton = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');
    const gambleModeButton = resourceManager.get('buttonContainer:buttonBar:gambleModeButton:button');
    const buyBonusButton = resourceManager.get('buttonContainer:buttonBar:buyBonusButton');

    goldenBetButton.previousAlpha = goldenBetButton.alpha;
    gambleModeButton.previousAlpha = gambleModeButton.alpha;
    buyBonusButton.previousAlpha = buyBonusButton.alpha;

    await Promise.all([
      _bgTrail.fadeOffLozs(),
      game.tweenFromToAsync(
        slotContainer,
        {
          alpha: 1,
        },
        {
          alpha: 0,
          duration: 0.5,
        }
      ),
      game.tweenFromToAsync(
        goldenBetButton,
        {
          alpha: goldenBetButton.alpha,
        },
        {
          alpha: 0,
          duration: 0.5,
        }
      ),
      game.tweenFromToAsync(
        gambleModeButton,
        {
          alpha: gambleModeButton.alpha,
        },
        {
          alpha: 0,
          duration: 0.5,
        }
      ),
      game.tweenFromToAsync(
        buyBonusButton,
        {
          alpha: buyBonusButton.alpha,
        },
        {
          alpha: 0,
          duration: 0.5,
        }
      ),
    ]);

    const burst1 = resourceManager.get('slotContainer:reelsBacker:BurstContainer:Burst1');
    const burst2 = resourceManager.get('slotContainer:reelsBacker:BurstContainer:Burst2');
    burst1.visible = false;
    burst2.visible = false;

    // fade out golden bet
    // fade out buy bonus
    // fade out gamble mode button
    // fade out the panels on the beanstalk
    resourceManager.getController('inputOverlord').setState('freeSpinsIntro');

    goldenBetButton.alpha = goldenBetButton.previousAlpha;
    gambleModeButton.alpha = gambleModeButton.previousAlpha;
    buyBonusButton.alpha = buyBonusButton.previousAlpha;

    resourceManager.get('slotContainer:reelsBorderFreeSpins').visible = true;
    resourceManager.get('slotContainer:reelsBorder').visible = false;
  }

  async function fadeOutComponentsBeforeFSToBGTransition() {
    const slotContainer = resourceManager.get('slotContainer');

    musicManager.onFreespinsOutroTransition();

    // lets remove jack 1st
    await _bgTrail.doJacksExitAnim();

    await Promise.all([
      _bgTrail.fadeOffLozs(),
      _bgTrail.fadeOutMinMultiplier(),
      game.tweenFromToAsync(
        slotContainer,
        {
          alpha: 1,
        },
        {
          alpha: 0,
          duration: 0.5,
        }
      ),
    ]);

    const burst1 = resourceManager.get('slotContainer:reelsBacker:BurstContainer:Burst1');
    const burst2 = resourceManager.get('slotContainer:reelsBacker:BurstContainer:Burst2');
    burst1.visible = true;
    burst2.visible = true;

    resourceManager.get('slotContainer:reelsBorderFreeSpins').visible = false;
    resourceManager.get('slotContainer:reelsBorder').visible = true;
  }

  async function fadeInComponentsAfterBGToFSTransition() {
    const slotContainer = resourceManager.get('slotContainer');

    await Promise.all([
      _bgTrail.fadeInMinMultiplier(),
      _bgTrail.fadeInLozs(),
      game.tweenFromToAsync(
        slotContainer,
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 0.5,
        }
      ),
    ]);
  }

  async function fadeInComponentsAfterFSToBGTransition() {
    const slotContainer = resourceManager.get('slotContainer');

    await Promise.all([
      _bgTrail.fadeInLozs(),
      game.tweenFromToAsync(
        slotContainer,
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 0.5,
        }
      ),
    ]);
  }

  async function moveBackgroundsToFreespins(durationInMS) {
    const landscapeBasegameBackgroundContainer = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeBasegameBackgroundContainer'
    );
    const portraitBasegameBackgroundContainer = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitBasegameBackgroundContainer'
    );

    const landscapeFSBackgroundContainer = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeFSBackgroundContainer'
    );
    const portraitFSBackgroundContainer = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitFSBackgroundContainer'
    );

    const landscapeCastleContainer = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeCastleContainer'
    );
    const landscapeBasegameCastle = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeCastleContainer:landscapeBasegameCastle'
    );
    const landscapeFSCastle = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeCastleContainer:landscapeFSCastle'
    );
    const portraitCastleContainer = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitCastleContainer'
    );
    const portraitBasegameCastle = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitCastleContainer:portraitBasegameCastle'
    );
    const portraitFSCastle = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitCastleContainer:portraitFSCastle'
    );

    const landscapeBasegameBackgroundTop = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeBasegameBackgroundContainer:landscapeBasegameBackgroundTop'
    );
    const portraitBasegameBackgroundTop = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitBasegameBackgroundContainer:portraitBasegameBackgroundTop'
    );
    const landscapeFSBackgroundBottom = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeFSBackgroundContainer:landscapeFSBackgroundBottom'
    );
    const portraitFSBackgroundBottom = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitFSBackgroundContainer:portraitFSBackgroundBottom'
    );

    landscapeBasegameBackgroundTop.visible = true;
    portraitBasegameBackgroundTop.visible = true;

    landscapeFSBackgroundContainer.alpha = 0;
    landscapeFSBackgroundContainer.visible = true;
    portraitFSBackgroundContainer.alpha = 0;
    portraitFSBackgroundContainer.visible = true;
    landscapeFSCastle.alpha = 0;
    landscapeFSCastle.visible = true;
    portraitFSCastle.alpha = 0;
    portraitFSCastle.visible = true;

    const fadeDurationInMS = durationInMS * 0.75;
    const fadeDelayDurationInMS = durationInMS * 0.25;
    // move
    await Promise.all([
      gameController.hideGameLogo(250),
      game.tweenFromToAsync(
        [landscapeFSBackgroundContainer, portraitFSBackgroundContainer, landscapeFSCastle, portraitFSCastle],
        {
          alpha: 0,
        },
        {
          alpha: 1,
          delay: fadeDelayDurationInMS / 1000,
          duration: fadeDurationInMS / 1000,
          ease: 'none',
        }
      ),
      game.tweenFromToAsync(
        [portraitCastleContainer],
        {
          y: 0,
        },
        {
          y: 1180,
          duration: durationInMS / 1000,
          ease: 'power1.inOut',
        }
      ),
      game.tweenFromToAsync(
        [landscapeCastleContainer],
        {
          y: 0,
        },
        {
          y: 640,
          duration: durationInMS / 1000,
          ease: 'power1.inOut',
        }
      ),
      game.tweenFromToAsync(
        [landscapeBasegameBackgroundContainer, landscapeFSBackgroundContainer],
        {
          y: 0,
        },
        {
          y: 720,
          duration: durationInMS / 1000,
          ease: 'power1.inOut',
        }
      ),
      game.tweenFromToAsync(
        [portraitBasegameBackgroundContainer, portraitFSBackgroundContainer],
        {
          y: 0,
        },
        {
          y: 1280,
          duration: durationInMS / 1000,
          ease: 'power1.inOut',
        }
      ),
    ]);

    landscapeBasegameCastle.visible = false;
    portraitBasegameCastle.visible = false;
    landscapeBasegameBackgroundContainer.visible = false;
    portraitBasegameBackgroundContainer.visible = false;
    landscapeFSBackgroundBottom.visible = false;
    portraitFSBackgroundBottom.visible = false;

    gameController.showGameLogo(250);
  }

  async function moveBackgroundsToBasegame(durationInMS) {
    const landscapeBasegameBackgroundContainer = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeBasegameBackgroundContainer'
    );
    const portraitBasegameBackgroundContainer = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitBasegameBackgroundContainer'
    );

    const landscapeFSBackgroundContainer = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeFSBackgroundContainer'
    );
    const portraitFSBackgroundContainer = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitFSBackgroundContainer'
    );

    const landscapeCastleContainer = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeCastleContainer'
    );
    const landscapeBasegameCastle = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeCastleContainer:landscapeBasegameCastle'
    );
    const landscapeFSCastle = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeCastleContainer:landscapeFSCastle'
    );
    const portraitCastleContainer = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitCastleContainer'
    );
    const portraitBasegameCastle = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitCastleContainer:portraitBasegameCastle'
    );
    const portraitFSCastle = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitCastleContainer:portraitFSCastle'
    );

    const landscapeBasegameBackgroundTop = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeBasegameBackgroundContainer:landscapeBasegameBackgroundTop'
    );
    const portraitBasegameBackgroundTop = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitBasegameBackgroundContainer:portraitBasegameBackgroundTop'
    );
    const landscapeFSBackgroundBottom = resourceManager.get(
      'landscapeBackgroundOrientationContainer:landscapeFSBackgroundContainer:landscapeFSBackgroundBottom'
    );
    const portraitFSBackgroundBottom = resourceManager.get(
      'portraitBackgroundOrientationContainer:portraitFSBackgroundContainer:portraitFSBackgroundBottom'
    );

    // turn on bottoms again
    landscapeBasegameCastle.visible = true;
    portraitBasegameCastle.visible = true;
    landscapeFSBackgroundBottom.visible = true;
    portraitFSBackgroundBottom.visible = true;
    landscapeBasegameBackgroundContainer.visible = true;
    portraitBasegameBackgroundContainer.visible = true;

    const fadeDurationOutMS = durationInMS * 0.75;
    const fadeDelayDurationInMS = durationInMS * 0.25;
    // move
    await Promise.all([
      game.tweenFromToAsync(
        [landscapeFSBackgroundContainer, portraitFSBackgroundContainer, landscapeFSCastle, portraitFSCastle],
        {
          alpha: 1,
        },
        {
          alpha: 0,
          delay: fadeDelayDurationInMS / 1000,
          duration: fadeDurationOutMS / 1000,
          ease: 'none',
        }
      ),
      game.tweenFromToAsync(
        [portraitCastleContainer],
        {
          y: 1180,
        },
        {
          y: 0,
          duration: durationInMS / 1000,
          ease: 'power1.inOut',
        }
      ),
      game.tweenFromToAsync(
        [landscapeCastleContainer],
        {
          y: 640,
        },
        {
          y: 0,
          duration: durationInMS / 1000,
          ease: 'power1.inOut',
        }
      ),
      game.tweenFromToAsync(
        [landscapeBasegameBackgroundContainer, landscapeFSBackgroundContainer],
        {
          y: 720,
        },
        {
          y: 0,
          duration: durationInMS / 1000,
          ease: 'power1.inOut',
        }
      ),
      game.tweenFromToAsync(
        [portraitBasegameBackgroundContainer, portraitFSBackgroundContainer],
        {
          y: 1280,
        },
        {
          y: 0,
          duration: durationInMS / 1000,
          ease: 'power1.inOut',
        }
      ),
    ]);

    landscapeFSCastle.visible = false;
    portraitFSCastle.visible = false;
    landscapeFSBackgroundContainer.visible = false;
    portraitFSBackgroundContainer.visible = false;
    landscapeBasegameBackgroundTop.visible = false;
    portraitBasegameBackgroundTop.visible = false;
  }

  async function transitionIntoSky() {
    const movePromise = moveBackgroundsToFreespins(2000);
    const maskInGoldBeanstalkPromise = _bgTrail.maskInGoldBeanstalk(2000);

    await Promise.all([movePromise, maskInGoldBeanstalkPromise]);
  }

  async function transitionFromSky() {
    const movePromise = moveBackgroundsToBasegame(2000);
    const maskOutGoldBeanstalkPromise = _bgTrail.maskOutGoldBeanstalk(2000);

    await Promise.all([movePromise, maskOutGoldBeanstalkPromise]);
  }

  async function showFreeSpinsIntroPanel(numFreeSpinsAwarded, cbWhenPressed = null) {
    const freeSpinsIntro = resourceManager.get('freeSpinsIntroContainer:FreeSpinsIntro');

    await freeSpinsIntro.show(numFreeSpinsAwarded, cbWhenPressed);
  }

  async function showFreeSpinsOutroPanel(numFreeSpinsAwarded, winAmount, showCongrats) {
    const freeSpinsOutro = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro');
    await freeSpinsOutro.show(numFreeSpinsAwarded, winAmount, showCongrats);
  }

  async function showFreeSpinsOutroNoWinPanel(numFreeSpinsAwarded) {
    const freeSpinsOutroNoWin = resourceManager.get('freeSpinsOutroNoWinContainer:FreeSpinsOutroNoWin');
    await freeSpinsOutroNoWin.show(numFreeSpinsAwarded);
  }

  async function bgToFSTransition(fromGamble = false) {
    // we need to animate the scatter symbols again

    // these should only animate if we came from a proper scatter win
    // not from a gamble
    if (!fromGamble) {
      await PayAnywhereWinAnimator.playScatterSymbolAnimations();
    }

    resourceManager.getController('autoplayController').cancel();

    await fadeOutComponentsBeforeBGToFSTransition();

    // and once finished we need to animate going up into the clouds etc
    await transitionIntoSky();

    _bgTrail.clearUpgradeCounter();
    _bgTrail.setMinMultiplier(gameController.inBuyASuperBonus ? 20 : 2); // need this number from the comms
    _bgTrail.reset();
    _bgTrail.respositionLozForFreeSpins();

    await Promise.all([_bgTrail.doJacksEntranceAnim(), fadeInComponentsAfterBGToFSTransition()]);
  }

  async function fsToBGTransition() {
    await fadeOutComponentsBeforeFSToBGTransition();

    // and once finished we need to animate going up into the clouds etc
    await transitionFromSky();

    _bgTrail.reset();
    _bgTrail.respositionLozForBaseGame();

    await Promise.all([_bgTrail.doJacksExitAnim(), fadeInComponentsAfterFSToBGTransition()]);
  }

  async function showFreeSpinsRetriggerPanel(spinsAdded) {
    const freeSpinsRetrigger = resourceManager.get('freeSpinsRetriggerContainer:FreeSpinsRetrigger');
    await freeSpinsRetrigger.show(spinsAdded);
  }

  async function updateFreeSpinsMeter(extraFS) {
    const duration = 750 / extraFS;
    const _freeSpinsMeter = resourceManager.get('freeSpinsMeterContainer:freeSpinsMeter');
    for (let i = 0; i < extraFS; i++) {
      await timerManager.delayAsync(duration);
      soundManager.play('fsIncrement');
      _freeSpinsMeter.addSpins(1);
    }
  }

  async function onFreespinsRetrigger(task) {
    let temp = task;
    temp.join();

    await PayAnywhereWinAnimator.presentScatterWin();

    await showFreeSpinsRetriggerPanel(task.data.spinsAdded);

    await updateFreeSpinsMeter(task.data.spinsAdded);

    await timerManager.delayAsync(750);

    // once dismissed leave the event
    temp.leave();
    temp = undefined;
  }

  async function onFreespinsRetriggerDead() {
    // dont think we really need to care about this
  }

  // // this is the function which is called when entering free spins
  async function onFreespinsStart(task) {
    let temp = task;
    temp.join();

    musicManager.onFreespinsIntroTransition();

    await bgToFSTransition(temp.data.fromGamble);

    musicManager.fadeFSLevels(
      musicManager.FREESPINS_INTROLEVEL, //
      musicManager.fadeLevelTimeIn,
      musicManager.fadeLevelTimeOut
    );

    _freeSpinsMeter.resetMeter();
    _freeSpinsMeter.addSpins(task.data.freeSpinsAwarded);

    // once there, show the free spins intro pop up
    await showFreeSpinsIntroPanel(task.data.freeSpinsAwarded, () => {
      _freeSpinsMeter.showMeter();
    });

    // once dismissed leave the event
    temp.leave();
    temp = undefined;
  }

  function onFreespinsStartDead(task) {
    _winnings = 0;

    freespinsMode(true);
    hideSpinButton();
    startSpins();
  }

  function startSpins() {
    startGame();

    gdk.getNextGameOutcome(function () {});
  }

  function startGame() {
    gameController.slamStopRequested = false;
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_LEVEL1, //
      musicManager.fadeLevelTimeIn,
      musicManager.fadeLevelTimeOut
    );

    _outcomesPanel.removeEntries();

    const freeSpinsTotalWinPanel = resourceManager.get(
      'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel'
    );
    if (freeSpinsTotalWinPanel.visible === true) {
      freeSpinsTotalWinPanel.hide(100, true);
      gameController.showGameLogo();
    } else {
      freeSpinsTotalWinPanel.reset();
    }

    gameController.resetWinnings();

    gameData.numPops = 0;

    freespins.spinTask = undefined;

    _freeSpinsMeter.useSpin();

    playSpinSound();

    slotMachine.clearReels(gameController.colossalData);
    console.log('freespins::switchState to CLEAR_REELS');
    freespins.stateMachine.switchState('CLEAR_REELS');
  }

  function hideSpinButton() {
    gameData.inputOverlord.setState('freespinsEnabled');
  }

  // function onFreespinsAwardedEnd() {
  //   showSpinButton();
  //   gdk.getNextGameOutcome(function () {});
  // }

  function showSpinButton() {
    _spinButton.visible = true;
  }

  function onFreespinsDataEvent(task) {
    _spinsRemaining = task.num;
    startGame();
    gdk.getNextGameOutcome(function () {});
  }

  async function onFreespinsEndEvent(task) {
    _endFreespinsTask = task;
    _endFreespinsTask.join();

    let freeSpinsWin = _endFreespinsTask.data.finalFsWinnings;
    let triggeringScatterWins = _endFreespinsTask.data.triggeringScatterWins;
    let isCapped = _endFreespinsTask.data.isCapped;

    if (isCapped) {
      // no need to wait
    } else {
      await timerManager.delayAsync(1000);
    }

    const freeSpinsTotalWinPanel = resourceManager.get(
      'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel'
    );
    if (freeSpinsTotalWinPanel.visible === true) {
      freeSpinsTotalWinPanel.hide();
      gameController.showGameLogo();
    }

    _bgTrail.stopPulsing();
    _bgTrail.stopBurst();

    // show free spins outro
    const hideMeterPromise = _freeSpinsMeter.hideMeter();
    // SRB im not 100% convinced we should be including the triggeringScatterWins here

    const amountWon = freeSpinsWin + triggeringScatterWins;
    const showCongrats = amountWon > gameController.globalHelperGetStake();

    if (amountWon > 0) {
      soundManager.play('freeSpinsEnd');
    }
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_INTROLEVEL, //
      musicManager.fadeLevelTimeIn,
      musicManager.fadeLevelTimeOut
    );

    if (amountWon === 0) {
      await showFreeSpinsOutroNoWinPanel(_endFreespinsTask.data.fsCount);
    } else {
      await showFreeSpinsOutroPanel(_endFreespinsTask.data.fsCount, amountWon, showCongrats);
    }

    await hideMeterPromise;
    _freeSpinsMeter.resetMeter();

    // show big win anim if we triggered it
    await showBigWin();

    // then transition back to base game
    await fsToBGTransition();

    musicManager.fadeLevels(
      musicManager.IDLELEVEL, //
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );

    endFreespins();

    _bonusAnimsPlayed = false;
  }

  async function showBigWin() {
    let totalWinnings = _endFreespinsTask.data.totalWinnings;
    let isCapped = _endFreespinsTask.data.isCapped;

    // before we show big win - was this a bonus buy
    let minWinRequired = 0;
    if (gameController.inBuyABonus || gameController.inBuyASuperBonus) {
      minWinRequired = gameController.globalHelperGetStake();
    }

    _bigWin = resourceManager.get('bigWin:BigWin');
    let isBigWin = _bigWin.willTriggerBigWin(totalWinnings, gameController.globalHelperGetBaseStake());

    if (isBigWin && totalWinnings >= minWinRequired) {
      _bigWin.start(
        totalWinnings,
        false,
        () => {
          _bgTrail.playJackBigWinAnim();
        },
        () => {
          _bgTrail.playJackNormalWinAnim();
        },
        null,
        'freespinsEnd'
      );
      await _bigWin.getBigWinPromise();
    }
  }

  function endFreespins() {
    freespinsMode(false);
    gameData.inputOverlord.setState('enabled');
    freespins.stateMachine.switchState('READY_TO_START');
    _endFreespinsTask.leave();
  }

  ////////////////////////////////////////////
  // define freespins Object to be returned //
  ////////////////////////////////////////////

  freespins = Object.create(spinFunctions);

  Object.defineProperties(freespins, {
    initialise: {
      value: initialise,
    },
    freespinsMode: {
      value: freespinsMode,
    },
    inFreespins: {
      get: function () {
        return _inFreeSpins;
      },
    },
    onFreespinsStart: {
      value: onFreespinsStart,
    },
    onFreespinsStartDead: {
      value: onFreespinsStartDead,
    },
    onFreespinsDataEvent: {
      value: onFreespinsDataEvent,
    },
    onFreespinsEndEvent: {
      value: onFreespinsEndEvent,
    },
    // onGambleResultEvent: {
    //   value: onGambleResultEvent,
    // },
    // onGambleResultEventDead: {
    //   value: onGambleResultEventDead,
    // },
    canEnableSpin: {
      value: canEnableSpin,
    },
    canShowSkip: {
      value: canShowSkip,
    },
    canEnableSkip: {
      value: canEnableSkip,
    },
    canShowSpin: {
      value: canShowSpin,
    },
    startGame: {
      value: startGame,
    },
  });

  ///////////////////
  // State Machine //
  ///////////////////

  StateMachine.Create(freespins);

  ///
  freespins.stateMachine.addState('WAITING_FOR_SERVER', function () {});

  ///
  freespins.stateMachine.addState('READY_TO_START', function () {});

  ///
  freespins.initialDropComplete = function (reelID) {
    --_initialDroppingFS;
  };

  freespins.areFreeSpinsActive = function () {
    return freespins._inFreeSpins;
  };

  ///
  freespins.stateMachine.addState('CLEAR_REELS', function () {
    // when reels have cleared we can drop in new positions
    // clear reels has a callback to reduce reelsDropping count

    if (freespins.phase.enter()) {
      _minGameTimerPromise = null;
      const license = gameData.license.toUpperCase();
      if (license === 'DE') {
        // ONLY de needs to slow down free spins (i think)
        _minGameTimerPromise = timerManager.delayAsync(gdk.minGameTime * 1000);
      }
      _initialDroppingFS = gameData.reels.length;
    }

    if (freespins.phase.hold()) {
      if (_initialDroppingFS === 0) {
        freespins.phase.step();
      }
    }

    // drop intial symbols needs to have finished before we do spin task leave and the symbols should all have landed
    if (freespins.phase.once()) {
      console.log('freespins::switchState to DROP_INITIAL_SYMBOLS');
      freespins.stateMachine.switchState('DROP_INITIAL_SYMBOLS');
    }
  });

  freespins.stateMachine.addState('DROP_INITIAL_SYMBOLS', function () {
    if (freespins.phase.hold()) {
      if (freespins.spinTask !== undefined) {
        freespins.phase.step();
      }
    }

    if (freespins.phase.once()) {
      _reelsSpinning = [true, true, true, true, true, true];
      _symbolCallbackFired = [];

      let _positions = freespins.spinTask.data.resultPanel.reelList.map(function (reel, index) {
        return reel.symbols.map(function (curr) {
          return curr.value;
        });
      });

      // calculate whether we display landing symbols
      _landedAnimsPlaying = gameController.calcLandingAnims(freespins.spinTask);
      gameController.calcAnticipation(freespins.spinTask);
      const eggMultiplierData = freespins.spinTask.data.eggMultiplierData;

      // now drop the symbols in
      // so colossals should only come in 50% of the time if there is a win
      // 25% of the time if no win
      const chance = freespins.spinTask.data.totalWinnings ? 50 : 25;
      const convertToColossals = gameController.startAnticipationDelayFromReel === -2 ? true : false; //gameController.rng.passChance(chance);
      gameController.colossalData = slotMachine.dropInitialSymbols(_positions, eggMultiplierData, convertToColossals);
    }

    if (freespins.phase.once()) {
      gameController._receivedResponse = true; // this allows slam stop
    }

    // don't proceed until all reels have finished spinning
    if (freespins.phase.hold()) {
      // check for any reels still spinning
      var spinComplete = true;
      for (var spinningIdx = 0; spinningIdx < _reelsSpinning.length; spinningIdx++) {
        spinComplete = spinComplete && !_reelsSpinning[spinningIdx];
      }

      if (spinComplete) {
        freespins.phase.step();
        gameController._receivedResponse = false;
      }
    }

    if (freespins.phase.once()) {
      // yes its and async, but in the next hold section, we wait for the var to be set
      // to true
      gameController.startAllLandAnimsDetection();
    }

    // wait for all landing anims to finish playing
    if (gameController.phase.hold()) {
      // all landing anims finished - hide them away
      if (gameController.allLandAnimsFinished) {
        gameController.phase.step();
      }
    }

    // do we have any winnings here?

    if (freespins.phase.once()) {
      // do we have any colossals on the reels?
      // if so these need converting back into small ones before we do anything
      const weHaveColossal = gameController.doWeHaveColossals(gameController.colossalData);
      if (weHaveColossal === true && freespins.spinTask.data.hasCascades > 0) {
        // only convert into smaller ones if we have wins
        console.log('freespins::switchState to CONVERT_COLOSSAL_TO_SMALL');
        freespins.stateMachine.switchState('CONVERT_COLOSSAL_TO_SMALL');
      } else {
        console.log('freespins::switchState to WAITING_FOR_SERVER');
        freespins.stateMachine.switchState('WAITING_FOR_SERVER');

        freespins.leaveSpinTask(freespins.spinTask.data.hasWins ? 0 : 500);
      }
    }
  });

  freespins.leaveSpinTask = async function (delay) {
    if (delay > 0) {
      const promises = [_minGameTimerPromise];
      promises.push(timerManager.delayAsync(delay));
      await Promise.all(promises);
    }
    freespins.spinTask.leave();
  };

  freespins.onSpinCompleteFS = function (reelID) {
    _reelsSpinning[reelID] = false;
  };

  freespins.stateMachine.addState('CONVERT_COLOSSAL_TO_SMALL', function () {
    if (freespins.phase.once()) {
      // convert all colossals
      slotMachine.convertColossalsIntoSmall(gameController.colossalData);
    }

    if (freespins.phase.hold()) {
      // wait for all to be converted
      if (slotMachine.isconvertingColossalsIntoSmall() !== true) {
        // must of finished
        freespins.phase.step();
      }
    }

    if (freespins.phase.once()) {
      gameController.colossalData = slotMachine.resetColossalData();

      console.log('gameController::switchState to WAITING_FOR_SERVER');
      freespins.stateMachine.switchState('WAITING_FOR_SERVER');

      if (freespins.spinTask) {
        freespins.spinTask.leave();
      }
    }
  });

  freespins.stateMachine.addState('PAYWINS', function () {});

  freespins.stateMachine.addState('PAY_TO_WINNINGS', function () {
    if (freespins.phase.enter()) {
      gameData.winningsMeter.countUp(freespins.winsTask.data.totalLineWinnings, 1000);
    }
    if (freespins.phase.hold()) {
      if (!gameData.winningsMeter.Props.isCounting) {
        freespins.winsTask.leave();
      }
    }
  });

  function update(delta) {
    _delta = delta;
    this.stateMachine.update();
  }

  messageBus.subscribe('game:FreeSpinsRetriggerDataEvent', onFreespinsRetrigger);
  messageBus.subscribe('game:FreeSpinsRetriggerDataEventDead', onFreespinsRetriggerDead);
  // messageBus.subscribe('game:FreeSpinsAwardEvent', onFreespinsAwarded);
  // messageBus.subscribe('game:FreeSpinsAwardEventDead', onFreespinsAwardedEnd);
  messageBus.subscribe('game:FreeSpinsStartEvent', onFreespinsStart);
  messageBus.subscribe('game:FreeSpinsStartEventDead', onFreespinsStartDead);
  messageBus.subscribe('game:FreeSpinsDataEventDead', onFreespinsDataEvent);
  messageBus.subscribe('game:FreeSpinsEndEvent', onFreespinsEndEvent);
  Reflex.addToUpdate(update.bind(freespins));

  return freespins;
})();
